type Ledger = {
  number: string;
  ledgerType: string;
};

export const getCorrectLedgerNumber = (ledgers: Array<Ledger>) => {
  const matchingLedger = ledgers?.find(
    (ledger) => ledger.ledgerType !== 'MAIN'
  );
  return matchingLedger ? matchingLedger.number : null;
};
